// src/components/RecaptchaV2.jsx
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";

export default function RecaptchaV2({ onChange }) {
  return (
    <ReCAPTCHA
      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      onChange={onChange} // reCAPTCHA renvoie automatiquement le token ici
    />
  );
}
